import Vue from "vue";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockTableRow from "@/helpers/editor/blocks/CmsBlockTableRow.js";
import CmsBlockTableColumn from "@/helpers/editor/blocks/CmsBlockTableColumn.js";

export default class CmsBlockTable extends CmsBlock {
    static typeDef = {
        name: `Table|Tableau`,
        glyph: `fa-table`,
        type: `table`,
        category: `layout`,
        isParent: true
    }

    get childClasses() {
        return [CmsBlockTableRow];
    }

    get maxChildren() {
        return 20;
    }

    constructor(data, page) {
        super(data, page);

        if (!data) {
            this.padding.init(0);
            this.columns = [];
            this.addColumn();
            this.addColumn();
            this.addColumn();

            // display
            this.maxColumns = 0;
            this.mediaQuery.mobile.maxColumns = 1;

            this.addChild(new CmsBlockTableRow());
            this.addChild(new CmsBlockTableRow());
            this.syncChildrenColumns();
        } else {
            this.columns = [];
            for (let item of data.columns) {
                this.columns.push(new CmsBlockTableColumn(item));
            }
            this.syncChildrenColumns();
        }
    }

    updateColumns() {
        let index = 0;
        for (let column of this.columns) {
            column.setIndex(index++);
        }
    }

    addColumn(index) {
        if (index === undefined) {
            index = this.columns.length;
        }

        this.columns.splice(index + 1, 0, new CmsBlockTableColumn());

        for (let row of this.children) {
            row.addColumn(index);
        }
        this.updateColumns();
    }

    swapColumns(oldIndex, newIndex) {
        for (let row of this.children) {
            // swap elements
            const oldItem = row.children[oldIndex];
            Vue.set(row.children, oldIndex, row.children[newIndex]);
            Vue.set(row.children, newIndex, oldItem);
        }
        this.updateColumns();
    }

    deleteColumn(index) {
        if (this.columns.length > 1) {
            for (let row of this.children) {
                row.children.splice(index, 1);
            }
            this.columns.splice(index, 1);
        }
        this.updateColumns();
    }

    onChildAdded(childBlock) {
        childBlock.syncColumnsFromTable(this);
    }

    syncChildrenColumns() {
        this.updateColumns();
        for (let row of this.children) {
            row.syncColumnsFromTable(this);
        }
    }
}
